import { useEffect, useState } from "react"

import { safeLoadStripe } from "../utils/stripeUtils"

/**
 * Hook to safely load and use Stripe.js
 * Returns the Stripe instance or null if it failed to load
 * @param {string} stripeKey - The Stripe publishable key
 * @param {object} options - Additional options for loadStripe
 * @returns {object} { stripe: Stripe | null, isLoading: boolean }
 */
export function useStripePromise(stripeKey, options = {}) {
  const [stripe, setStripe] = useState(null)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    if (typeof window === "undefined" || !stripeKey) {
      setStripe(null)
      setIsLoading(false)
      return
    }

    setIsLoading(true)
    const promise = safeLoadStripe(stripeKey, options)

    promise
      .then((stripeInstance) => {
        setStripe(stripeInstance)
        setIsLoading(false)
      })
      .catch(() => {
        // safeLoadStripe already handles errors and returns null
        setStripe(null)
        setIsLoading(false)
      })
  }, [stripeKey, JSON.stringify(options)])

  return { stripe, isLoading }
}
